import { LocationMessageDto } from 'Api/Features/Messages/Dtos/LocationMessageDto';
import { MessageEntityTypeDto } from 'Api/Features/Messages/Dtos/MessageEntityTypeDto';
import { NotificationTypeDto } from 'Api/Features/Notifications/Dtos/NotificationTypeDto';
import { LocationMessageUserDto } from 'Api/Features/Messages/Dtos/LocationMessageUserDto';
import { User } from 'Models/Users/User';
import { UserDto } from 'Api/Features/Users/Dtos/UserDto';

export class LocationMessage implements LocationMessageDto {
    constructor(dto: LocationMessageDto) {
        Object.assign(this, dto);
    }

    id = '';
    entityType?: MessageEntityTypeDto | null = null;
    entityId?: string | null;
    type?: NotificationTypeDto | null;
    title?: string | null;
    body?: string | null;
    date?: string;
    createdByUser?: LocationMessageUserDto | null;

    private _creator: User | null = null;

    public getConsoleUrl(locationId: string): string {
        return `/locations/${locationId}/announcements/${this.id}`;
    }

    get from(): User | null {
        if (this.createdByUser && !this._creator) {
            this._creator = new User({ ...this.createdByUser } as UserDto);
        }

        return this._creator;
    }

    get fromName(): string {
        const fromUser = this.from;
        return (fromUser) ? fromUser.name || '' : '';
    }
}
